import PropTypes from "prop-types";
import React, { useContext } from "react";

import { Badge, Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { PlacementFactory } from "@swa-ui/placements";
import { classNames } from "@swa-ui/string";

import { SystemMessagesContext } from "../SystemMessagesProvider";
import styles from "./NotificationCenter.module.scss";

/**
 * The NotificationCenter renders notifcation alert messages
 */
export const NotificationCenter = (props) => {
  const { className } = props;
  const { notificationMessagePlacementIds } = useContext(SystemMessagesContext);

  return (
    <div className={classNames(className, styles.notificationCenter)}>
      {notificationMessagePlacementIds.length > 0
        ? renderSystemMessages()
        : renderNoMessagesNotification()}
    </div>
  );

  function renderSystemMessages() {
    return notificationMessagePlacementIds.map((systemMessagePlacementId) => (
      <PlacementFactory id={systemMessagePlacementId} key={systemMessagePlacementId} />
    ));
  }

  function renderNoMessagesNotification() {
    return (
      <Badge className={styles.capsule} styleType="secondary" type="capsule">
        <Text italics>{i18n("DesktopSystemMessages__NO_ALERTS")}</Text>
      </Badge>
    );
  }
};

NotificationCenter.displayName = "NotificationCenter";
NotificationCenter.propTypes = {
  /** Additional classes for positioning the component. */
  className: PropTypes.string,
};
